<div class="filter-results-input-wrapper">
  <mat-form-field appearance="fill" class="filter-results-input" [style.width]="width">
    <input matInput (keyup)="applyFilter($event)" [placeholder]="placeholder" class="capitalized">
  </mat-form-field>
</div>
